/*
  eslint
  no-param-reassign: ["error", { "props": false }]
  no-console: "off"
*/
import Vue from 'vue';
import Vuex from 'vuex';
import _ from 'lodash';
import AdminStoreModule from './graphql/admin/store';
import PrimaryStoreModule from './graphql/primary/store';
import MapKitModule from './mapkit';
import AuthStoreModule from '../auth/auth0/store';
import assetViewState from './views/assets';
import analyticViewState from './views/analytics';
import deploymentViewState from './views/deployments';
import profileViewState from './views/profiles';
import actionViewState from './views/actions';
import logViewState from './views/logs_';
import alertViewState from './views/alerts';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth: AuthStoreModule,
    primary: PrimaryStoreModule,
    admin: AdminStoreModule,
    assetViewState,
    analyticViewState,
    deploymentViewState,
    actionViewState,
    profileViewState,
    logViewState,
    alertViewState,
    mk: MapKitModule,
  },
  state: {
    activeSection: '',
    scriptsLoaded: false,
    notAuthorized: false,
    showUserInfo: false,
    requestCount: 0,
    globalErrorMessage: null,
    breadcrumbs: [],
    gmt: true,
    siteEnv: process.env.VUE_APP_SITE_ENV,
    disabledControls: [],
    keys: {
      INSIGHTS_DISABLED: 'insights.disabledControls',
    },
    VUE_APP_GIT_VERSION: process.env.VUE_APP_GIT_VERSION,
    VUE_APP_GIT_HASH: process.env.VUE_APP_GIT_HASH,
    VUE_APP_GIT_BRANCH: process.env.VUE_APP_GIT_BRANCH,
    VUE_APP_BUILD_DATE: process.env.VUE_APP_BUILD_DATE,
  },
  mutations: {
    ADD_DISABLED_CONTROLS(state, payload) {
      if (!state.disabledControls.includes(payload)) {
        state.disabledControls.push(payload);
      }
    },
    REMOVE_DISABLED_CONTROLS(state, payload) {
      state.disabledControls = _.filter(state.disabledControls, payload);
    },
    SET_DISABLED_CONTROLS(state, payload) {
      state.disabledControls = payload;
    },
    SET_GMT(state, payload) {
      state.gmt = payload;
    },
    SET_SECTION(state, payload) {
      state.activeSection = payload;
    },
    SET_SCRIPTS_LOADED(state, payload) {
      state.scriptsLoaded = payload;
    },
    SET_NOT_AUTHORIZED(state, payload) {
      state.notAuthorized = payload;
    },
    SET_ORGANIZATION(state, payload) {
      state.organization = payload;
    },
    TOGGLE_USER_INFO(state) {
      state.showUserInfo = !state.showUserInfo;
    },
    SET_ASSET(state, payload) {
      state.asset = payload;
    },
    SET_ASSETS(state, payload) {
      state.assets = payload.items;
      state.assetsNextToken = payload.nextToken;
    },
    SET_DEPLOYMENT(state, payload) {
      state.deployment = payload;
    },
    SET_DEPLOYMENTS(state, payload) {
      state.deployments = payload.items;
      state.deploymentsNextToken = payload.nextToken;
    },
    SET_ANALYTIC(state, payload) {
      state.analytic = payload;
    },
    SET_ANALYTICS(state, payload) {
      state.analytics = payload.items;
      state.analyticsNextToken = payload.nextToken;
    },
    SET_PROFILE(state, payload) {
      state.profile = payload;
    },
    SET_PROFILES(state, payload) {
      state.profiles = payload.items;
      state.profilesNextToken = payload.nextToken;
    },
    SET_GLOBAL_ERROR_MESSAGE(state, payload) {
      state.globalErrorMessage = payload.message;
    },
    INCREMENT_REQUEST_COUNT(state) {
      state.requestCount += 1;
    },
    DECREMENT_REQUEST_COUNT(state) {
      if (state.requestCount > 0) {
        state.requestCount -= 1;
      }
    },
    SET_ACTION_CONFIGS(state, payload) {
      state.actionConfigs = payload;
    },
    SET_ACTION_CONFIGSS(state, payload) {
      state.actionConfigss = payload.items;
      state.actionConfigssNextToken = payload.nextToken;
    },
  },
  getters: {
    showLoader(state) {
      return state.requestCount > 0;
    },
  },
  actions: {
    async initializeData({ state, commit, dispatch }) {
      await dispatch('primary/getOrganization');

      const disabledControls = await dispatch('primary/getKeyValue', { key: state.keys.INSIGHTS_DISABLED });
      if (disabledControls.key !== null) {
        commit('SET_DISABLED_CONTROLS', JSON.parse(disabledControls.value));
      }
    },
    handleQueryError({ commit }, err) {
      if (err.message === 'GraphQL error: Not Authorized') {
        commit('SET_NOT_AUTHORIZED', true);
      } else if (_.has(err, 'networkError.statusCode')) {
        if (err.networkError.statusCode !== 401) {
          Vue.$log.error(err.networkError);
          Vue.$log.error(err.graphQLErrors);
        }
      } else {
        Vue.$log.error(err);
        commit('SET_GLOBAL_ERROR_MESSAGE', err);
      }
    },
    async login({ commit, dispatch }, payload) {
      commit('INCREMENT_REQUEST_COUNT');
      await dispatch('auth/loginUser', payload);
      commit('DECREMENT_REQUEST_COUNT');
    },
    async doMutation({ commit, dispatch }, payload) {
      Vue.$log.debug('Making GraphQL Request (mutation)');
      commit('INCREMENT_REQUEST_COUNT');
      const result = await payload.client.mutate({
        mutation: payload.query,
        fetchPolicy: 'no-cache',
        variables: payload.variables,
      }).catch((err) => {
        dispatch('handleQueryError', err);
        Vue.$log.error('GraphQL Error');
      });
      commit('DECREMENT_REQUEST_COUNT');
      if (result) {
        Vue.$log.debug('Got GraphQL Result');
      }
      if (payload.key) {
        return result.data[payload.key];
      }
      return result;
    },
    async doQuery({ commit, dispatch }, payload) {
      Vue.$log.debug('Making GraphQL Request (query)');
      commit('INCREMENT_REQUEST_COUNT');
      const result = await payload.client.query({
        query: payload.query,
        fetchPolicy: 'network-only',
        variables: payload.variables,
      }).catch((err) => {
        dispatch('handleQueryError', err);
        Vue.$log.error('GraphQL Error');
      });
      commit('DECREMENT_REQUEST_COUNT');
      if (result) {
        Vue.$log.debug('Got GraphQL Result');
      }
      if (payload.key) {
        return result.data[payload.key];
      }
      return result;
    },
  },
});
